import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconSuccess, IconClose } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';

import './styles.scss';

const ConvertToLocationSuccessBanner = ({
    onClose,
    isVisible
}) => {
    const { t: translate } = useTranslation();

    if (!isVisible) {
        return null;
    }

    return (
        <div className='convert-to-location-success-banner'>
            <div className='convert-to-location-success-banner__icon'>
                <IconSuccess width={20} height={20} color={colors.jungleGreen} />
            </div>
            <div className='convert-to-location-success-banner__content'>
                <span
                    dangerouslySetInnerHTML={{
                        __html: translate('ABB.Powertrain.Frontend.convertToLocationSuccessMessage')
                    }}
                />
            </div>
            <button
                className='convert-to-location-success-banner__close'
                onClick={onClose}
                type='button'
                aria-label={translate('ABB.Powertrain.Frontend.closeLabel') || 'Close'}
            >
                <IconClose
                    width={16}
                    height={16}
                />
            </button>
        </div>
    );
};

ConvertToLocationSuccessBanner.propTypes = {
    onClose: PropTypes.func.isRequired,
    isVisible: PropTypes.bool
};

ConvertToLocationSuccessBanner.defaultProps = {
    isVisible: false
};

export default ConvertToLocationSuccessBanner;
